const defaultMeta = {
  requiresAuth: true,
}

export default [
  {
    path: '/user/teams',
    name: 'userTeams',
    meta: { ...defaultMeta, title: 'My Teams - Innovation Law Lab Platform' },
    component: _ => import('@/views/MyTeamsView.vue'),
  },
  {
    path: '/user/teams/:id',
    name: 'userTeamsDetails',
    meta: defaultMeta,
    props: true,
    redirect: { name: 'user-team-members' },
    component: _ => import('@/views/TeamDetailsView.vue'),
    children: [
      {
        path: 'members',
        name: 'user-team-members',
        meta: { ...defaultMeta, sectionName: 'Team Members', title: 'Team Members - Innovation Law Lab Platform' },
        props: true,
        component: _ => import('@/components/Team/TeamMembers.vue'),
      },
      {
        path: 'access-requests',
        name: 'user-team-access-requests',
        meta: { ...defaultMeta, sectionName: 'Team Access Requests', title: 'Team Access Requests - Innovation Law Lab Platform' },
        props: true,
        component: _ => import('@/components/Team/TeamAccessRequests.vue'),
      },
      {
        path: 'roles',
        name: 'user-team-roles',
        meta: { ...defaultMeta, sectionName: 'Team Roles', title: 'Team Roles - Innovation Law Lab Platform' },
        props: true,
        component: _ => import('@/components/Team/TeamRoles.vue'),
      },
      {
        path: 'records',
        name: 'user-team-records',
        meta: { ...defaultMeta, sectionName: 'Team Records', title: 'Team Records - Innovation Law Lab Platform' },
        props: true,
        component: _ => import('@/components/Team/TeamRecords.vue'),
      },
      {
        path: 'legal-cases',
        name: 'user-team-legal-cases',
        meta: { ...defaultMeta, sectionName: 'Team Legal Cases', title: 'Team Legal Cases - Innovation Law Lab Platform' },
        props: true,
        component: _ => import('@/components/Team/TeamLegalCases.vue'),
      },
      {
        path: 'parties',
        name: 'user-team-parties',
        meta: { ...defaultMeta, sectionName: 'Team Parties', title: 'Team Parties - Innovation Law Lab Platform' },
        props: true,
        component: _ => import('@/components/Team/TeamParties.vue'),
      },
      {
        path: 'excluded',
        name: 'user-team-restricted',
        meta: { ...defaultMeta, sectionName: 'Restricted Resources', title: 'Restricted Resources - Innovation Law Lab Platform' },
        props: true,
        component: _ => import('@/components/Team/TeamRestricted.vue'),
      },
    ],
  },
]
